import Image from 'next/image';
import { CDN2 } from '@/helpers/api';
import { Button } from 'antd';
import Link from 'next/link';

export default function HeroSection() {
  return (
    <div className="w-full bg-gray-50">
      <div className="px-4 md:px-32 xl:px-4 mx-auto w-full flex flex-col-reverse md:flex-row justify-between items-center gap-x-4 max-w-7xl">
        <div className="flex flex-col gap-3 flex-1">
          <h2 className="text-xl lg:text-3xl xl:text-5xl font-bold">
            ONAIRPARKING.COM
          </h2>
          <p className="text-xl leading-snug">
            Since 2016, we’ve been delivering results for both our partners and parkers at over 80 major airports across the U.S. Our proven platform drives revenue, fills empty spaces, and connects travelers with unbeatable parking deals every day.
          </p>
          <p className="text-gray-500 text-sm">
            <span>888.487.2754 </span>
            {' '}•{' '}
            <span> @ONAIRPARKING</span>
          </p>

          <Link href="/partner/letter">
            <Button type="primary" >
              Note from our Founders
            </Button>
          </Link>
        </div>
        <div className="flex-1 flex justify-end">
          <Image
            src={CDN2() + '/staticmyapp/letter/logo-letter.webp'}
            alt="logo"
            width="448"
            height="448"
            quality={100}
          />
        </div>
      </div>
    </div>
  );
}
